import React from "react";
import "./index.css";
import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { CardMedia } from "@mui/material";
import Login from "./routes/login";
import Register from "./routes/register";
import ForgotPassword from "./routes/ForgotPassword";
import Home from "./routes/home";
import Edit from "./routes/edit";
import Profile from "./routes/profile";
import Notifications from "./routes/notifications";
import Header from './routes/Header';
import Header1 from './routes/Header1';
import Header2 from './routes/Header2';
import Header3 from './routes/Header3';
import BottomNav from './routes/BottomNav';
import Chats from './routes/Chats';
import ChatBox from './routes/chatbox';
import News from './routes/News';
import SavedNews from './routes/SavedNews';
import DirectChatBox from './routes/DirectChatBox';
import Miperfil from "./routes/perfil";
import Terms from './routes/terms';
import Publish from './routes/Publish';
import { isLoggedIn, endSession } from "./session";
import { usePushNotifications } from "./usePushNotifications";
import { CallProvider } from "./CallProvider";
import logo from "./imgs/logo192.png";

const Loading = () => (
  <div className="loading-container">
    <CardMedia
      className="loading-img"
      alt="Cargando..."
      component="img"
      image={logo}
    />
  </div>
);

const App = () => {
  const [user, setUser] = React.useState(null);
  const [loading, setLoading] = React.useState(true); // Estado para el mensaje de carga
  usePushNotifications();

  // Verificar si el usuario está autenticado al cargar la aplicación
  React.useEffect(() => {
    const checkAuth = async () => {
      try {
        const user = await isLoggedIn();
        setUser(user);
      } catch (error) {
        console.error("Error al verificar la autenticación:", error);
      } finally {
        setLoading(false); // Indica que la verificación ha terminado
      }
    };

    checkAuth();
  }, []);

  // Función para cerrar sesión
  const handleLogout = async () => {
    try {
      await endSession();
      setUser(null);
    } catch (error) {
      console.error("Error al cerrar sesión:", error);
    }
  };

  return (
    <Router>
      <CallProvider>
      {loading ? (
        <Loading />
      ) : (
        <Routes>
          <Route
            path="/"
            element={user ? <Home handleLogout={handleLogout} /> : <Login />}
          />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/home" element={<Home handleLogout={handleLogout} />} />
          <Route path="/edit" element={<Edit />} />
          <Route path="/notifications" element={<Notifications />} />
          <Route path="/Header" element={<Header />} />
          <Route path="/Header1" element={<Header1 />} />
          <Route path="/Header2" element={<Header2 />} />
          <Route path="/Header3" element={<Header3 />} />
          <Route path="/Chats" element={<Chats />} />
          <Route path="/chatbox/:chatId/:userId/:authUserId" element={<ChatBox />} />
          <Route path="/direct-chat/:chatId/:otherId/:authId" element={<DirectChatBox />} />
          <Route path="/news" element={<><Header /><News /><BottomNav /></>} />
          <Route path="/saved-news" element={<SavedNews />} />
          <Route path="/BottomNav" element={<BottomNav />} />
          <Route path="/perfil/:uid" element={<Miperfil />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/publish" element={<Publish />} />
        </Routes>
      )}
      </CallProvider>
    </Router>
  );
};

export default App;
